import { useStore } from "@/stores/useStore";
import { useMemo } from "react";
import { CustomerUpdatesConfig } from "@/types/v2";
import {
  DEFAULT_COMPLETED_ON_TIME_BUFFER_MIN,
  DEFAULT_CUSTOMER_UPDATE_SNOOZE_MIN,
} from "@/lib/const";

export const useCustomerUpdatesConfig = () => {
  const shop = useStore((s) => s.shop);
  return useMemo<CustomerUpdatesConfig>(
    () =>
      shop?.shopConfig?.customerUpdates ?? {
        enabled: false,
        defaultCompletedOnTimeBufferMin: DEFAULT_COMPLETED_ON_TIME_BUFFER_MIN,
        defaultSnoozeBufferMin: DEFAULT_CUSTOMER_UPDATE_SNOOZE_MIN,
        requireComments: false,
      },
    [shop?.shopConfig?.customerUpdates]
  );
};
